import React from "react";

const ChoiceButtons = ({ options, active, setActive }) => {
  return (
    <div className="flex flex-row gap-x-2 pt-4">
      {options.map((option, index) => {
        return (
          <button
            key={`choice-btn-${index}`}
            className={`${
              active === index && "selected"
            } default w-[100px] h-[100px] md:w-[200px] md:h-[200px] text-2xl`}
            onClick={() => {
              setActive(index);
            }}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
};

export default ChoiceButtons;
